module.exports = __webpack_public_path__ + "img/video-thumb-7-nl.666f6354.png";